<template>
  <v-toolbar class="ml-4 wd-100" color="transparent">
    <v-toolbar-title style="font-size: 24px; font-weight: bold"
      >{{ this.projeto }} - Stakeholders Externos</v-toolbar-title
    >
    <StakeHolderEModal v-if="isDev" @stakeholder-criado="fetchStakeholders" />
  </v-toolbar>

  <v-table
    class="ma-8 mt-1 usecase--table elevation-1"
    style="background: transparent"
    fixed-header="true"
    density="comfortable"
    ><thead class="text-grey">
      <tr>
        <th style="border-left: thin solid #efefef" class="text-left text-grey">
          Nome
        </th>
        <th style="border-left: thin solid #efefef" class="text-left text-grey">
          E-mail
        </th>
        <th
          style="border-left: thin solid #efefef"
          class="rounded-te-lg text-left text-grey"
        >
          Req relacionados
        </th>
        <th
          v-if="isDev"
          style="border-left: thin solid #efefef"
          class="text-left text-grey"
        >
          Ações
        </th>
      </tr>
    </thead>
    <div class="split"></div>
    <tbody>
      <tr v-for="item in stakeHolderE" :key="item">
        <td style="border-left: thin solid #efefef" class="text-left">
          {{ item.tb_stakeholder_externo.nome }}
        </td>

        <td style="border-left: thin solid #efefef" class="text-left">
          {{ item.tb_stakeholder_externo.email }}
        </td>

        <td style="border-left: thin solid #efefef" class="text-left">
          {{
            reqRelacionados[item.tb_stakeholder_externo.id_stakeholder]
              ? reqRelacionados[item.tb_stakeholder_externo.id_stakeholder]
                  ?.length == 0
                ? 'Nenhum'
                : reqRelacionados[item.tb_stakeholder_externo.id_stakeholder]
                    ?.length <= 3
                ? reqRelacionados[
                    item.tb_stakeholder_externo.id_stakeholder
                  ]?.join(', ')
                : reqRelacionados[item.tb_stakeholder_externo.id_stakeholder]
                    ?.slice(0, 3)
                    .join(', ') + '...'
              : '...'
          }}
        </td>

        <td
          v-if="isDev"
          style="border-left: thin solid #efefef"
          class="text-left"
        >
          <div class="d-inline-block mr-6">
            <EditStakeHolderEModal
              @stakeholder-editado="fetchStakeholders"
              :id="item.tb_stakeholder_externo.id_stakeholder"
            />
          </div>
          <div class="d-inline-block ml-2">
            <DeleteStakeHolderEModal
              @stakeholder-removido="fetchStakeholders"
              :id="item.tb_stakeholder_externo.id_stakeholder"
            />
          </div>
        </td>
      </tr>
    </tbody>
  </v-table>

  <v-container v-if="this.isLoading" class="d-flex justify-center align-center">
    <v-progress-circular class="text-center" indeterminate size="20" />
  </v-container>
</template>

<script>
/**
 * @module StakeHolderETable
 * @desc Tela que lista os stakeholders externos de um projeto
 * @vue-data {Array.<Object>} [stakeHolderE=[]] Lista de objetos
 * com informações sobre os stakeholders externos
 * @vue-data {String} idProjeto - O id do projeto
 * @vue-data {String} [projeto=''] Nome do projeto
 * @vue-data {Boolean} [isLoading=false] Flag que indica se
 * as informações já foram carregadas
 * @vue-computed {Boolean} isDev - Flag que indica se o usuário
 * atual é desenvolvedor no projeto
 */
import axios from 'axios';

import DeleteStakeHolderEModal from '@/components/dialogs/DeleteStakeHolderEModal.vue';
import EditStakeHolderEModal from '@/components/dialogs/EditStakeHolderEModal.vue';
import StakeHolderEModal from '@/components/dialogs/StakeHolderEModal.vue';
import store from '@/store/store';
const apiUrl = process.env.VUE_APP_API_URL;

export default {
  name: 'StackHolderETable',
  components: {
    StakeHolderEModal,
    EditStakeHolderEModal,
    DeleteStakeHolderEModal,
  },
  data() {
    return {
      stakeHolderE: [],
      idProjeto: null,
      projeto: '',
      isLoading: false,
      reqRelacionados: {},
      stakeHolderIds: [],
    };
  },
  created() {
    this.idProjeto = this.$route.params.idProjeto;
    this.projeto = localStorage.getItem('projeto');
    this.fetchStakeholders();
  },
  computed: {
    isDev() {
      return localStorage.getItem('formaAtuacao') === '"DESENVOLVEDOR"';
    },
  },
  methods: {
    fetchReqRelacionados() {
      this.isLoading = true;
      for (let i = 0; i < this.stakeHolderIds.length; i++) {
        axios
          .get(
            // eslint-disable-next-line
            `${apiUrl}/api/v1/stakeHolderE/reqRelacionados/${this.stakeHolderIds[i]}`,
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`,
              },
            },
          )
          .then((res) => {
            this.reqRelacionados[this.stakeHolderIds[i]] = res.data.req.map(
              (req) => req.identificacao,
            );
            console.log(this.reqRelacionados);
          })
          .catch((error) => console.log(error))
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    /**
     * Faz uma requisição HTTP para obter os stakeholders externos.
     */
    fetchStakeholders() {
      this.isLoading = true;
      const apiUrl = process.env.VUE_APP_API_URL;

      axios
        .get(apiUrl + '/api/v1/stakeHolderE/projeto/' + this.idProjeto, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((res) => {
          this.stakeHolderE = res.data.stakeHolderE;
          this.stakeHolderIds = res.data.stakeHolderE.map(
            (st) => st.id_stakeholder,
          );
          console.log(this.stakeHolderIds);
          this.fetchReqRelacionados();
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style>
.usecase--table .split {
  background-color: #f9f8f8;
  height: 1rem;
}

.usecase--table tbody tr {
  background-color: #fff;
}

.usecase--table a {
  text-decoration: none;
  color: black;
}
</style>
